import { Table, TableContainer, TablePagination } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';

export const ListViewWrapper = styled.div`
  width: 100%;
  position: absolute;
  padding: 0 40px 0;
  left: 15px;
  background-color: ${({ theme }) => theme.pageBackground};
  display: flex;

  & > div {
    width: 100%;
  }

  .MuiTableContainer-root {
    max-width: unset;
  }

  &&& {
    .sticky-column {
      border-radius: 8px 0 0 8px;

      table {
        border-right: none;
      }
    }

    .main-table {
      border-radius: 0 8px 8px 0;
      background-color: ${({ theme }) => theme.tableFooterBackgroundColor};
      table {
        border-left: none;
        border-bottom: 0;
      }
    }

    .MuiTableRow-root {
      height: 54px;
    }
  }
`;

export const StyledTable = styled((props) => <Table {...props} />)`
  .MuiTableRow-root {
    padding: 0 15px;
  }

  .MuiTableBody-root {
    display: block;
    height: calc(100vh - 435px);
    overflow-y: scroll;
  }
`;

export const NoRows = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background-color: ${({ theme }) => theme.evenRow};
  color: ${({ theme }) => theme.rowColor};
  height: 100%;
`;

export const StyledTableContainer = styled((props) => <TableContainer {...props} />)`
  margin-bottom: 75px;
`;

export const StyledTablePagination = styled((props) => <TablePagination {...props} />)`
  && {
    /* position: fixed;
    bottom: 78px;
    background-color: ${({ theme }) => theme.tablePaginationBackground};
    border-top: none;
    color: ${({ theme }) => theme.tablePaginationColor}; */

    /* .MuiIconButton-root {
      background: ${({ theme }) => theme.tablePaginationBtnBackground};

      svg {
        fill: ${({ theme }) => theme.tablePaginationBtnColor};
      }
    } */
  }
`;
